import { useFormik } from "formik"
import * as Yup from "yup"
import React from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
  CardSubtitle,
  Spinner,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"

const ProviderForm = ({ onSubmit, loading, error, formMode, provider }) => {
  // Initialize Formik Hook for Validation
  // This hook manages form state and validation using Formik.
  const validationType = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: provider ? provider?.title : "",
    },
    validationSchema: Yup.object().shape({
      title: Yup.string().required("This name is required"),
    }),
    onSubmit: values => {
      onSubmit(values)
    },
  })

  return (
    <Card>
      <CardBody>
        {/*
          CustomHeaderTitle Component Props:
          
          - loading: Boolean flag to display loading state
          - title: String to display as the header title
          - rowCount: Boolean to show/hide the row number selector
          - lgColumn: Number to control the width of columns based on layout needs
          - onChangeRowNumber: Callback function to handle row number selection change
          - orderingList: Boolean to show/hide ordering dropdown
          - onChangeOrdering: Callback function triggered when the ordering option is changed
          - searchBox: Boolean to show/hide search input box
          - onSearchHandler: Function called on key up in the search box
          - rightBtn: Boolean to show/hide right-side button (for example, a back button)
          - rightBtnTitle: String for setting the right button's label
          - rightBtnRoute: Route for the right button's navigation
          - exportBtn: Boolean to show/hide export button
          - onExportBtnClick: Callback for when the export button is clicked
          - exportBtnLoading: Boolean flag to show loading state during export functionality
          - advnacedSearchBtn: Boolean to show/hide advanced search button
          - advnacedSearchBtnTitle: String to display the advanced search button label
          - onAdvancedSearch: Callback function when the advanced search button is clicked (used to toggle collapse)
          - orderingOptions: Array of options to populate the ordering dropdown (value and name pair)
        */}
        <CustomHeaderTitle
          loading={loading}
          title={formMode === "Edit" ? "Edit Provider" : "Add Provider"}
          lgColumn={3}
          rowCount={false}
          orderingList={false}
          searchBox={false}
          rightBtn={true}
          rightBtnTitle={"Back"}
          rightBtnRoute={"/providers"}
        />

        <Form
          onSubmit={e => {
            e.preventDefault()
            validationType.handleSubmit()
            return false
          }}
        >
          <div className="mb-3">
            <Label className="form-label">Name</Label>
            <Input
              name="title"
              defaultValue={provider?.title}
              placeholder="Title"
              type="text"
              onChange={validationType.handleChange}
              onBlur={validationType.handleBlur}
              value={validationType.values.title || ""}
              invalid={
                (validationType.touched.title && validationType.errors.title) ||
                error?.title?.[0]
                  ? true
                  : false
              }
            />
            {(validationType.touched.title && validationType.errors.title) ||
            error?.title?.[0] ? (
              <FormFeedback type="invalid">
                {validationType.errors.title || error?.title?.[0]}
              </FormFeedback>
            ) : null}
          </div>

          <div className="d-flex flex-wrap gap-2">
            <Button type="submit" color="primary" disabled={loading}>
              {loading
                ? "Please Wait..."
                : formMode === "Add"
                ? "Submit"
                : "Update"}
            </Button>
          </div>
        </Form>
      </CardBody>
    </Card>
  )
}

export default ProviderForm
